import { ListCategoryProductsDto } from "types/dto/ListCategoryProductsDto";
import { ApiService } from "./apiService"




export const getRootCategories = async () => {
    return await ApiService.get(`product-categories/root/categories`);
}

export const getCategories = async (categoryId: string) => {
    return await ApiService.get(`product-categories/${categoryId}/categories`);
}

export const getCategoryProducts = async (dto: ListCategoryProductsDto) => {
    return await ApiService.get(`product-categories/${dto.categoryId}/products?page=${dto.page}&size=${dto.size}`)
}